import DB from 'offline/db'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/game/data/versions.php
export default {
	run: function(filter, data, config, global) {
		global.version = {}
		global.versions = {}
		global.versionsReference = {}
		global.versionIndex = []
		if (!global.owners) return

		var ownerKeys = Object.keys(global.owners)
		var seenVersionIds = {}
		for (var oi = 0; oi < ownerKeys.length; oi++) {
			var ownerRows = global.owners[ownerKeys[oi]] || []
			for (var ri = 0; ri < ownerRows.length; ri++) {
				var versionId = parseInt(ownerRows[ri].game_version_id || 0, 10)
				if (!versionId || seenVersionIds[versionId]) continue
				seenVersionIds[versionId] = true
				global.versionIndex.push(versionId)
			}
		}

		if (!global.versionIndex.length) return

		var rows = DB.query('SELECT * FROM game_version WHERE game_version_id IN(' + Util.in(global.versionIndex) + ')')
		for (var i = 0; i < rows.length; i++) {
			var v = rows[i]
			if (!global.versions[v.game_id]) global.versions[v.game_id] = []
			// Match PHP `Model\Game\Version::to_array` — expose only the four
			// curated display fields. Otherwise the raw SQL columns leak into
			// the insight package (game_version_avatar, *_date_*, *_worth_*
			// etc.) and diverge from prod payloads.
			global.versions[v.game_id].push({
				id: parseInt(v.game_version_id, 10),
				name: v.game_version_name || '',
				localised: v.game_version_localised || '',
				year: parseInt(v.game_version_year, 10) || 0
			})
			global.versionsReference[v.game_version_id] = v
		}
	}
}
